import { createFileRoute } from "@tanstack/react-router";
import NRIInvestors from "@/pages/NRIInvestors";

export const Route = createFileRoute("/nri-investors")({
  head: () => {
    const title = "NRI Real Estate Investment in Mumbai | FEMA, Remittance & Property Advisory | MNRE";
    const description = "Specialist real estate advisory for NRIs investing in Mumbai property. Remote virtual tours, title diligence, NRE/NRO banking, repatriation, and FEMA compliance.";
    const canonicalUrl = "https://mnre.in/nri-investors";
    const ogImage = "https://mnre.in/blog-covers/mumbai-luxury-penthouse-interior.jpg";

    const breadcrumbJsonLd = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: "https://mnre.in/" },
        { "@type": "ListItem", position: 2, name: "NRI Investors", item: canonicalUrl },
      ],
    };

    const faqJsonLd = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Can NRIs buy residential property in India without RBI approval?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Non-Resident Indians (NRIs) and Overseas Citizens of India (OCIs) can freely purchase residential and commercial properties in India under general RBI permission without prior approval. Agricultural land, plantation property, and farmhouses require special approval.",
          },
        },
        {
          "@type": "Question",
          name: "Do NRIs need to travel to India to complete a property purchase?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Not necessarily. Most transactions can be executed remotely through a registered Power of Attorney (PoA) in favour of a trusted representative or legal advisor, along with virtual video verification.",
          },
        },
        {
          "@type": "Question",
          name: "How is TDS handled when an NRI buys property in Mumbai?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "When buying from a resident seller, standard TDS under Section 194-IA (1%) applies. If buying from an NRI seller, the buyer must deduct TDS under Section 195 on capital gains (typically 20% plus surcharge and cess) unless a lower tax deduction certificate is obtained from the Income Tax department.",
          },
        },
        {
          "@type": "Question",
          name: "Can NRI rental income from Mumbai property be repatriated abroad?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Rental income deposited into an NRO account can be repatriated abroad up to USD 1 million per financial year under RBI/FEMA Liberalised Remittance Scheme (LRS) regulations, supported by Form 15CA and Form 15CB certified by a Chartered Accountant.",
          },
        },
      ],
    };

    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "website" },
        { property: "og:url", content: canonicalUrl },
        { property: "og:image", content: ogImage },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
        { name: "twitter:image", content: ogImage },
      ],
      links: [{ rel: "canonical", href: canonicalUrl }],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify([breadcrumbJsonLd, faqJsonLd]),
        },
      ],
    };
  },
  component: NRIInvestors,
});
